import { customerApi } from "../../utils/apiConfig";

export const uploadHumanResources = (
  userId,
  file,
  title,
  description,
  reminder
) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);
  formData.append("excel", file);

  if (reminder?.reminderActive) {
    formData.append("reminderActive", "true");

    formData.append(
      "reminder",
      JSON.stringify({
        startDate: reminder.startDate,
        endDate: reminder.endDate,
        note: reminder.note || "",
        notifyBefore: reminder.notifyBefore || 30, //  düz sayı gönder
      })
    );
  }

  return customerApi.post("/uploadInsanKaynaklariDocument", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateHumanResources = (
  updatedId,
  userId,
  file,
  title,
  description,
  reminder
) => {
  const formData = new FormData();
  formData.append("updatedId", updatedId);
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);

  if (file) {
    formData.append("excel", file);
  }

  if (reminder?.reminderActive) {
    formData.append("reminderActive", "true");

    formData.append(
      "reminder",
      JSON.stringify({
        startDate: reminder.startDate,
        endDate: reminder.endDate,
        note: reminder.note || "",
        notifyBefore: reminder.notifyBefore || 30,
      })
    );
  }

  return customerApi.post("/updateInsanKaynaklariDocument", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getHumanResources = () => {
  return customerApi.get("/getInsanKaynaklariDocument", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getInsanKaynaklariPersonelList = () => {
  return customerApi.get("/getInsanKaynaklariPersonelList", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};



